/**
 * Merges a static (base) payload with a dynamic (custom) payload.
 *
 * Properties from the dynamic payload will overwrite properties from the static payload
 * in case of a name collision.
 */
export const combinePayloads = (staticPayload: object | null | undefined, dynamicPayload: object | null | undefined): object => ({
  ...(staticPayload ?? {}),
  ...(dynamicPayload ?? {}),
});
